import styled from "styled-components";
import { useState, useEffect } from "react";
import FormStringInput from "../../../../../../components/FormControls/FormStringInput";
import FormSelectWithLabel from "../../../../../../components/FormControls/FormSelectWithLabel";
import PrimaryButton from "../../../../../../components/FormControls/PrimaryButton";
import WarningButton from "../../../../../../components/FormControls/WarningButton";
import request from "../../../../../../api/request";
import MessageBox from "../../../../../../components/MessageBox";
import { NotificationManager } from 'react-notifications';

const StyledAuditorSettings = styled.div`
`;

const WhiteBoard = styled.div`
    background-color: white;
    width: 600px;
    box-sizing: border-box;
    min-height: 543px;
    padding: 30px;
    margin-bottom: 30px;
    color: ${(props) => props.theme.color.gray};
`;

const Title = styled.span`
    display: block;
    color: ${(props) => props.theme.color.primaryblue};
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 5px;
`;

function AuditorSettings(props) {

    const {branches, selectedBranch, regionsList, refreshBranchesCallback} = props;

    let currentYear = new Date().getFullYear();
    const [showMessageBox, setShowMessageBox] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [auditorTitle, setAuditorTitle] = useState('Mr.');
    const [auditorSurname, setAuditorSurname] = useState('');
    const [auditorForename, setAuditorForename] = useState('');
    const [auditorPhone, setAuditorPhone] = useState('');
    const [auditorEmail, setAuditorEmail] = useState('');
    const [auditorAddress1, setAuditorAddress1] = useState('');
    const [auditorAddress2, setAuditorAddress2] = useState('');
    const [auditorAddress3, setAuditorAddress3] = useState('');
    const [auditorAddress4, setAuditorAddress4] = useState('');
    const [auditorAddress5, setAuditorAddress5] = useState('');
    
    const [needsValidation, setNeedsValidation] = useState(false);

    let callingTitles = ['Mr.', 'Mrs.', 'Miss.', 'Ms.', 'Dr.', 'Prof.', 'Sir', 'The Rev.', 'The Hon.'];

    const onSaveChanges = async () => {
        setIsSaving(true);
        let branchData = {};
        branchData.RecordType = selectedBranch.RecordType;
        branchData.BranchCommitteeCode = selectedBranch.BranchCommitteeCode;
        branchData.RecordName = selectedBranch.RecordName;
        branchData.DivisionCode = selectedBranch.DivisionCode;
        branchData.AuditorTitle = auditorTitle;
        branchData.AuditorSurname = auditorSurname.length ? auditorSurname : null;
        branchData.AuditorForenames = auditorForename.length ? auditorForename : null;
        branchData.AuditorPhone = auditorPhone.length ? auditorPhone : null;
        branchData.AuditorEmail = auditorEmail.length ? auditorEmail : null;
        branchData.AuditorAddress1 = auditorAddress1.length ? auditorAddress1 : null;
        branchData.AuditorAddress2 = auditorAddress2.length ? auditorAddress2 : null;
        branchData.AuditorAddress3 = auditorAddress3.length ? auditorAddress3 : null;
        branchData.AuditorAddress4 = auditorAddress4.length ? auditorAddress4 : null;
        branchData.AuditorAddress5 = auditorAddress5.length ? auditorAddress5 : null;

        const resp = (await request('database', 'updateBranchAuditor', [branchData]));
        if (resp.ok && refreshBranchesCallback) {
            refreshBranchesCallback(selectedBranch.BranchCommitteeCode, selectedBranch.RecordType);
            NotificationManager.success('Updated auditor details');
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsSaving(false);
    };

    const deleteBranch = async () => {
        setShowMessageBox(false);

        setIsDeleting(true);
        let deleteData = {};
        deleteData.RecordType = selectedBranch.RecordType;
        deleteData.RecordName = selectedBranch.RecordName;
        deleteData.BranchCommitteeCode = selectedBranch.BranchCommitteeCode;
        const resp = (await request('database', 'deleteBranch', [deleteData]));
        if (resp.ok && refreshBranchesCallback) {
            refreshBranchesCallback();
            NotificationManager.success('Branch deleted');
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsDeleting(false);
    }

    useEffect(() => {
        if (selectedBranch) {
            setNeedsValidation(false);
            setAuditorTitle(selectedBranch.AuditorTitle ? selectedBranch.AuditorTitle : '');
            setAuditorSurname(selectedBranch.AuditorSurname ? selectedBranch.AuditorSurname : '');
            setAuditorForename(selectedBranch.AuditorForenames ? selectedBranch.AuditorForenames : '');
            setAuditorPhone(selectedBranch.AuditorPhone ? selectedBranch.AuditorPhone : '');
            setAuditorEmail(selectedBranch.AuditorEmail ? selectedBranch.AuditorEmail : '');
            setAuditorAddress1(selectedBranch.AuditorAddress1 ? selectedBranch.AuditorAddress1 : '');
            setAuditorAddress2(selectedBranch.AuditorAddress2 ? selectedBranch.AuditorAddress2 : '');
            setAuditorAddress3(selectedBranch.AuditorAddress3 ? selectedBranch.AuditorAddress3 : '');
            setAuditorAddress4(selectedBranch.AuditorAddress4 ? selectedBranch.AuditorAddress4 : '');
            setAuditorAddress5(selectedBranch.AuditorAddress5 ? selectedBranch.AuditorAddress5 : '');
        }
    }, [selectedBranch, branches]);

    return (
        <StyledAuditorSettings>
            <WhiteBoard>
                <Title>Auditor / Examiner</Title>
                <FormSelectWithLabel label='Title' items={callingTitles} value={auditorTitle} onChange={(e) => setAuditorTitle(e.target.value)} style={{width:150, height:35, paddingLeft:13}}></FormSelectWithLabel>
                <div style={{display:'flex'}}>
                    <FormStringInput label='Surname' value={auditorSurname} onChange={(val) => setAuditorSurname(val)} inputStyle={{width:245}}></FormStringInput>
                    <FormStringInput label='Forename' value={auditorForename} onChange={(val) => setAuditorForename(val)} inputStyle={{width:245}} style={{marginLeft: 15}}></FormStringInput>
                </div>
                <Title style={{marginTop:30}}>Contact details</Title>
                <div style={{display:'flex'}}>
                    <FormStringInput label='Telephone' value={auditorPhone} onChange={(val) => setAuditorPhone(val)} inputStyle={{width:245}}></FormStringInput>
                    <FormStringInput label='Email address' value={auditorEmail} onChange={(val) => setAuditorEmail(val)} inputStyle={{width:245}} style={{marginLeft: 15}}></FormStringInput>
                </div>
                <div style={{display:'flex'}}>
                    <FormStringInput label='Address' value={auditorAddress1} onChange={(val) => setAuditorAddress1(val)} inputStyle={{width:245}}></FormStringInput>
                    <FormStringInput label='None' value={auditorAddress2} onChange={(val) => setAuditorAddress2(val)} inputStyle={{width:245}} style={{marginLeft: 15, color:'transparent'}}></FormStringInput>
                </div>
                <div style={{display:'flex'}}>
                    <FormStringInput value={auditorAddress3} onChange={(val) => setAuditorAddress3(val)} inputStyle={{width:245}}></FormStringInput>
                    <FormStringInput value={auditorAddress4} onChange={(val) => setAuditorAddress4(val)} inputStyle={{width:245}} style={{marginLeft: 15}}></FormStringInput>
                </div>
                <FormStringInput value={auditorAddress5} onChange={(val) => setAuditorAddress5(val)} inputStyle={{width:245}}></FormStringInput>
            </WhiteBoard>
            <div>
                <WarningButton caption='Delete branch' isLoading={isDeleting} onClick={() => setShowMessageBox(true)} style={{width:120}}></WarningButton>
                <PrimaryButton caption='Save changes' isLoading={isSaving} onClick={() => onSaveChanges()} style={{width:150, float:'right'}}></PrimaryButton>
            </div>

            { showMessageBox && <MessageBox
                text = 'Are you sure you want to delete this branch?'
                yesText = 'Delete branch'
                noText = 'Cancel'
                isWarning = {true}
                handleClickYes = {() => {
                        deleteBranch();
                    }
                }
                handleClickNo = {() => setShowMessageBox(false)}
            />}
        </StyledAuditorSettings>
    )
}

export default AuditorSettings;